// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"168":"5a16f80d","211":"7527ca78","224":"c9a2ed77","536":"ff40990a","785":"dc35d3e1"}[chunkId] + ".css";
};